import React from 'react';
export const TopHeader = () => {
  return <div className="bg-[#0a1022] w-full py-2" data-id="element-230">
      <div className="max-w-3xl mx-auto px-4" data-id="element-231">
        <div className="flex justify-between items-center" data-id="element-232">
          <p className="text-white text-sm" data-id="element-233">Health & Wellness Report</p>
          <p className="text-white text-sm" data-id="element-234">September 2025</p>
        </div>
      </div>
    </div>;
};